/** Admin card — replace the handwritten signature shown at the end of
 * every Insight article and Spotlight story. */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import ImageUploadField from "@/components/ImageUploadField";

export const SignatureSetting = () => {
  const [url, setUrl] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/public/site-settings")
      .then((r) => setUrl(r.data?.signature_url || ""))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const save = async (nextUrl) => {
    setUrl(nextUrl);
    try {
      await api.put("/site-settings", { signature_url: nextUrl });
      toast.success(nextUrl ? "Signature updated — it now appears on all stories and articles." : "Signature removed.");
    } catch {
      toast.error("Could not save the signature.");
    }
  };

  if (!loaded) return null;

  return (
    <div className="bg-white border border-[#EBE3D2] rounded-xl p-5" data-testid="signature-setting">
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div className="max-w-sm">
          <h3 className="font-display font-semibold text-[#2A1810]">Handwritten Signature</h3>
          <p className="text-xs text-[#6B5944] mt-1 leading-relaxed">
            Appears at the end of every Spotlight story and Insight article. Upload a transparent
            PNG to replace it — the change applies everywhere instantly.
          </p>
          {url && (
            <div className="mt-4 flex items-center gap-3">
              <div className="bg-[#FDFBF5] border border-[#EBE3D2] rounded-lg p-3">
                <img src={url} alt="Current signature on cream" className="h-12 object-contain" data-testid="signature-preview-light" />
              </div>
              <div className="bg-[#17100B] rounded-lg p-3">
                <img src={url} alt="Current signature on dark" className="h-12 object-contain" data-testid="signature-preview-dark" />
              </div>
            </div>
          )}
        </div>
        <div className="w-full sm:w-72">
          <ImageUploadField value={url} onChange={save} label="Replace signature (transparent PNG)" testid="signature-upload" />
        </div>
      </div>
    </div>
  );
};

export default SignatureSetting;
